import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import { _OfficeRole } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../../../../theme/Component/usePaginator';
import { SelectRol } from '../../../../../../admin/select/SelectRol';
import { BasicButton } from '../../../../../../theme/Component/BasicButton';


interface Props {
    idOffice: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const OfficeRoleEditor = ({ idSelector, onChange, label, returnType = "ID", render, idOffice }: Props) => {

    const { instance, lista, setLista } = useDataBean(_OfficeRole)
    const [id, setID] = useState(null);
    const [Role, setRole] = useState<any>(null)
    const paginador = usePaginator();
    const modal = useModal("Role de Oficina", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDOfficeRole == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    useEffect(() => {
        getLista();
    }, [idOffice, paginador.page])

    const getLista = () => {

        instance.getOfficeRoleCatalog(idOffice, Role, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDOfficeRole', visible: true },
        { title: 'Role', property: 'RoleName', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Role de Oficina"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectRol idSelector={Role} onChange={(e: any) => { setRole(e) }}></SelectRol>
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDOfficeRole); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}